import {
  Button,
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@devhop/ui";
import {
  ChevronRightIcon,
  FileTextIcon,
  ListChecksIcon,
  PlusIcon,
  TagsIcon,
} from "lucide-react";

type QuickLink = {
  title: string;
  description: string;
  icon: typeof ListChecksIcon;
  onClick: () => void;
};

type FormsDashboardQuickLinksCardProps = {
  links: QuickLink[];
};

export function FormsDashboardQuickLinksCard({
  links,
}: FormsDashboardQuickLinksCardProps) {
  return (
    <Card className="h-full">
      <CardHeader className="space-y-1">
        <CardTitle className="text-lg">ທາງລັດ</CardTitle>
        <CardDescription>ເຂົ້າໜ້າຈັດການຟອມທີ່ໃຊ້ບໍ່</CardDescription>
      </CardHeader>
      <CardContent className="flex flex-col gap-3">
        {links.map((link) => {
          const Icon = link.icon;
          return (
            <Button
              key={link.title}
              type="button"
              variant="outline"
              className="h-auto justify-between gap-4 px-4 py-4 text-left"
              onClick={link.onClick}
            >
              <span className="flex min-w-0 items-start gap-3">
                <span className="flex size-9 shrink-0 items-center justify-center rounded-lg bg-muted">
                  <Icon className="size-4 text-muted-foreground" />
                </span>
                <span className="min-w-0 space-y-0.5">
                  <span className="block font-medium text-sm">{link.title}</span>
                  <span className="block text-muted-foreground text-xs leading-relaxed">
                    {link.description}
                  </span>
                </span>
              </span>
              <ChevronRightIcon className="size-4 shrink-0 text-muted-foreground" />
            </Button>
          );
        })}
      </CardContent>
    </Card>
  );
}

export const quickLinkIcons = {
  list: ListChecksIcon,
  categories: TagsIcon,
  new: PlusIcon,
  forms: FileTextIcon,
} as const;
